export const URL_SORT_ORDERS = { ascend: "asc", descend: "desc" };

export const TABLE_SORT_ORDERS = { asc: "ascend", desc: "descend" };
